import { render, staticRenderFns } from "./MessageSearch.vue?vue&type=template&id=62c56693&scoped=true"
import script from "./MessageSearch.vue?vue&type=script&lang=js"
export * from "./MessageSearch.vue?vue&type=script&lang=js"
import style0 from "./MessageSearch.vue?vue&type=style&index=0&id=62c56693&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c56693",
  null
  
)

export default component.exports